<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold">Move To Unit</p>
        <v-form v-model="isFormValid">
          <v-row v-for="(period, index) in contractPeriods" :key="index">
            <v-col class="pb-0" cols="12" sm="12" md="4">
              <v-menu
                :ref="`moveInDateMenuRef_${index}`"
                v-model="period.moveInDateMenu"
                :close-on-content-click="false"
                :return-value.sync="period.moveInDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="period.moveInDate"
                    label="Start Date"
                    prepend-inner-icon="mdi-calendar-month"
                    outlined
                    dense
                    v-on="on"
                    @click="setDateIndex(index)"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="period.moveInDatePicker"
                  :allowed-dates="allowedDatesMoveIn"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="period.moveInDateMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="saveMoveInRef(index, period.moveInDatePicker)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="pb-0" cols="12" sm="12" md="4">
              <v-menu
                :ref="`moveOutDateMenuRef_${index}`"
                v-model="period.moveOutDateMenu"
                :close-on-content-click="false"
                :return-value.sync="period.moveOutDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="period.moveOutDate"
                    label="End Date"
                    prepend-inner-icon="mdi-calendar-month"
                    outlined
                    dense
                    v-on="on"
                    @click="setDateIndex(index)"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="period.moveOutDatePicker"
                  :allowed-dates="allowedDatesMoveOut"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="period.moveOutDateMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="saveMoveOutRef(index, period.moveOutDatePicker)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="pb-0" cols="12" sm="12" md="4">
              <v-currency-field
                v-model="period.rentFee"
                type="number"
                :rules="rentFeeRules"
                label="Rent Fee"
                prepend-inner-icon="mdi-cash"
                append-outer-icon="mdi-close"
                outlined
                dense
                required
                @click:append-outer="removePeriod(index)"
              >
              </v-currency-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="4">
              <v-btn text x-small color="primary" @click="addPeriod">
                <v-icon left x-small>mdi-plus-circle</v-icon> Add another period
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-select
                v-model="selectedUnit"
                :items="getVacantUnits()"
                label="Bed"
                prepend-inner-icon="mdi-bed-empty"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="6">
              <v-currency-field
                v-model="downPayment"
                type="number"
                :rules="downPaymentRules"
                label="Down Payment"
                prepend-inner-icon="mdi-transfer-down"
                required
                outlined
                dense
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="6" md="6">
              <v-checkbox
                v-model="depositPaid"
                label="Deposit Paid"
              ></v-checkbox>
            </v-col>
            <!-- temporarily disable this in preference for catch up -->
            <!-- <v-col class="py-0" cols="12" sm="6" md="6">
              <v-checkbox v-model="firstMonthPaid" label="First month paid"></v-checkbox>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-select
                v-model="daysBeforeNotif"
                :items="daysBeforeNotifItems"
                label="Remind me:"
                prepend-inner-icon="mdi-calendar-today"
                outlined
                required
                multiple
                chips
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            :disabled="!isFormValid"
            text
            @click="finish"
          >
            Finish
          </v-btn>
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <CreateDepositPaymentRequest
      ref="createDepositPaymentRequest"
    ></CreateDepositPaymentRequest>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'
import CreateDepositPaymentRequest from '../units/CreateDepositPaymentRequest.vue'

export default {
  components: {
    CreateDepositPaymentRequest
  },
  data: () => ({
    reservationId: -1,
    tenantId: -1,
    /**
     * @type {{bedId: number, addressId: string}}
     */
    selectedUnit: null,
    dialog: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 700,
      zIndex: 200
    },
    rentFee: 0,
    downPayment: 0,
    collectionDay: dayjs().date(),
    daysBeforeNotif: [1, 7],
    moveInDate: dayjs()
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    moveOutDate: dayjs()
      .add(1, 'year')
      .subtract(1, 'day')
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    moveInDatePicker: dayjs()
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    moveOutDatePicker: dayjs()
      .add(1, 'year')
      .subtract(1, 'day')
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    date: new Date().toISOString().substr(0, 10),
    dateIndex: -1,
    contractPeriods: [],
    moveInDateMenu: false,
    moveOutDateMenu: false,
    downPaymentRules: [
      (v) => Number.isInteger(parseInt(v)) || 'Down Payment must be a number.'
    ],
    rentFeeRules: [
      (v) => !!v || 'Rent Fee is Required.',
      (v) => Number.isInteger(parseInt(v)) || 'Rent Fee must be a number.'
      // v => v > 0 || 'Rent Fee must be greater than 0'
    ],
    collectionDayRules: [
      (v) => !!v || 'Collection Day is Required.',
      (v) =>
        Number.isInteger(parseInt(v)) || 'Collection Day must be a number.',
      (v) => (v > 0 && v < 31) || 'Collection Day must be from 1 to 30'
    ],
    daysBeforeNotifItems: [
      { value: 1, text: '1 day before' },
      { value: 7, text: '1 week before' },
      { value: 14, text: '2 weeks before' },
      { value: 30, text: '30 days before' }
    ],
    // paid: false,
    depositPaid: false,
    firstMonthPaid: false,
    loading: true,
    snackbar: false,
    snackbarText: '',
    isFormValid: false
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    },
    propertyUnitList() {
      return this.$store.getters['units/getPropertyUnitList']
    }
  },
  watch: {
    date() {
      this.moveInDate = this.formatDate(this.date)
    }
  },
  created() {
    this.reloadUnitsDiscreet()
  },
  methods: {
    async open(params) {
      this.loading = false
      this.tenantId = params.tenantId
      this.reservationId = params.reservationId

      this.contractPeriods = [
        {
          moveInDate: this.moveInDate,
          moveInDatePicker: this.moveInDatePicker,
          moveInDateMenu: this.moveInDateMenu,
          moveOutDate: this.moveOutDate,
          moveOutDatePicker: this.moveOutDatePicker,
          moveOutDateMenu: this.moveOutDateMenu
        }
      ]

      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
    async finish() {
      let createDepositPaymentRequest = false
      if (!this.depositPaid) {
        createDepositPaymentRequest =
          await this.$refs.createDepositPaymentRequest.open()
        if (!createDepositPaymentRequest) {
          return
        }
      }
      this.loading = true
      let bed = {}
      try {
        // re-format contract periods to conform to local timezone
        this.contractPeriods = this.contractPeriods.map((contractPeriod) => ({
          moveInDate: dayjs(contractPeriod.moveInDate).format(),
          moveOutDate: dayjs(contractPeriod.moveOutDate).format()
        }))
        bed = await this.$store.dispatch('reservations/moveToBedAction', {
          reservationId: this.reservationId,
          tenantId: this.tenantId,
          bedId: this.selectedUnit.bedId,
          // rentFee: this.rentFee,
          downPayment: this.downPayment,
          // collectionDay: this.collectionDay,
          daysBeforeNotif: this.daysBeforeNotif,
          // moveInDate: this.moveInDate,
          // moveOutDate: this.moveOutDate,
          contractPeriods: this.contractPeriods,
          // paidUntilDate: this.firstMonthPaid?dayjs(this.moveInDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD'):dayjs(this.moveInDate).subtract(1, 'day').format('YYYY-MM-DD'),
          firstMonthPaid: this.firstMonthPaid,
          attachments: this.attachments
        })

        let items = []
        // if deposit only, category is 'misc'. otherwise if it includes rent, the category is 'rental'
        let paymentCategory = 'misc'

        if (this.depositPaid) {
          items.push({
            item: 'down_payment',
            description: `Down Payment for move in to ${bed.bedName}`,
            quantity: 1,
            amount: parseFloat(this.downPayment)
          })
        } else {
          if (createDepositPaymentRequest == 'yes') {
            // create payment request here
            await this.$store.dispatch('payments/collectUtilities', {
              tenantId: this.tenantId,
              bedId: this.selectedUnit.bedId,
              category: 'misc',
              description: `Down Payment for move in to ${bed.bedName}`,
              amount: parseFloat(this.downPayment),
              startDate: dayjs(this.contractPeriods[0].moveInDate).format(),
              endDate: dayjs(this.moveInDate)
                .add(1, 'month')
                .subtract(1, 'day')
                .format(),
              leaseId: bed.leaseId
            })
          }
        }
        if (this.firstMonthPaid) {
          items.push({
            item: 'rental',
            description: `Rental for ${bed.bedName} from ${dayjs(
              this.contractPeriods[0].moveInDate
            ).format('MMMM D, YYYY')} to ${dayjs(
              this.contractPeriods[0].moveInDate
            )
              .add(1, 'month')
              .subtract(1, 'day')
              .format('MMMM D, YYYY')}`,
            quantity: 1,
            amount: parseFloat(this.contractPeriods[0].rentFee)
          })
          paymentCategory = 'rental'
        }

        if (items.length) {
          await this.$store.dispatch('payments/createGenericPaymentAction', {
            tenantId: this.tenantId,
            bedId: this.selectedUnit.bedId,
            items: items,
            amountPaid: items.reduce((total, item) => total + item.amount, 0), //parseFloat(this.rentFee) + parseFloat(this.downPayment),
            startDate: dayjs(this.contractPeriods[0].moveInDate).format(),
            endDate: dayjs(this.contractPeriods[0].moveInDate)
              .add(1, 'month')
              .subtract(1, 'day')
              .format(),
            category: paymentCategory,
            leaseId: bed.leaseId
          })
        }

        this.loading = false
        this.resolve(true)
        this.dialog = false
        this.$root
          .$confirm({
            title: 'New Tenant',
            message: `The tenant has been moved to bed.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(async () => {
            window.location.reload()
          })
      } catch (err) {
        this.snackbarText = err.data
        this.snackbar = true
        this.loading = false
      }
    },
    allowedDatesMoveOut(val) {
      const moveInDate = this.contractPeriods[this.dateIndex].moveInDate
      return dayjs(val).isAfter(dayjs(moveInDate))
      // return parseInt(val.split('-')[2], 10) % 2 === 0
    },
    allowedDatesMoveIn(val) {
      if (this.dateIndex <= 0) return true
      const previousMoveOutDate =
        this.contractPeriods[this.dateIndex - 1].moveOutDate
      return dayjs(val).isAfter(dayjs(previousMoveOutDate))
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    /**
     * Returns a list of units with the ancestry in the `text` field
     * @returns {{text: string, value: {bedId: number, addressId: string}}[]}
     */
    getUnitList(units, unitList, parents) {
      for (const unit of units) {
        if (unit.children && unit.children.length) {
          this.getUnitList(unit.children, unitList, parents + `${unit.name} / `)
        }
        if (unit.type === 'unit') {
          unitList.push({
            value: {
              addressId: unit.addressId,
              bedId: unit.transientData.bedId
            },
            text: parents + unit.name
          })
        }
      }
    },
    /**
     * @description Returns a list of vacant units
     * @returns {{text: string, value: {bedId: number, addressId: string}}[]}
     */
    getVacantUnits() {
      if (!this.propertyUnitList || !this.propertyUnitList.units) {
        return []
      }
      const unitList = []
      this.getUnitList(this.propertyUnitList.units, unitList, '')
      const suppData =
        this.$store.getters['units/getPropertyUnitListSupplementaryDataMap']

      return unitList.filter((u) => {
        const bedId = u.value.bedId

        return this.bedStatus(suppData[String(bedId)]) === 'vacant'
      })
    },
    bedStatus(supplementaryData) {
      if (supplementaryData) {
        return supplementaryData.bed.status
      }
      return 'vacant'
    },
    saveMoveOutRef(index, value) {
      const ref = `moveOutDateMenuRef_${index}`
      this.$refs[ref][0].save(value)
    },
    saveMoveInRef(index, value) {
      const ref = `moveInDateMenuRef_${index}`
      this.$refs[ref][0].save(value)
    },
    addPeriod() {
      const lastIndex = this.contractPeriods.length - 1
      const lastContractPeriod = this.contractPeriods[lastIndex]
      const moveInDate = dayjs(lastContractPeriod.moveOutDate).add(1, 'day')
      const moveOutDate = moveInDate.add(1, 'year').subtract(1, 'day')
      this.contractPeriods.push({
        moveInDate: moveInDate.format('YYYY-MM-DD'),
        moveInDatePicker: moveInDate.format('YYYY-MM-DD'),
        moveInDateMenu: false,
        moveOutDate: moveOutDate.format('YYYY-MM-DD'),
        moveOutDatePicker: moveOutDate.format('YYYY-MM-DD'),
        moveOutDateMenu: false
      })
    },
    removePeriod(index) {
      if (index <= 0) return
      this.contractPeriods.splice(index, 1)
    },
    setDateIndex(index) {
      this.dateIndex = index
    },
    async reloadUnitsDiscreet() {
      await Promise.all([
        this.$store.dispatch('units/fetchPropertyUnitList').then(() => {
          this.loading = false
        }),
        this.$store.dispatch('units/fetchPropertyUnitListSupplementaryData')
      ])
    }
  }
}
</script>
